// extracted by css-extract-rspack-plugin
export default {"leads-modal":"LeadsModal-module__leads-modal--hQLJ2","leadsModal":"LeadsModal-module__leads-modal--hQLJ2"};